import { render, staticRenderFns } from "./InstitutionalQnrThanksView.vue?vue&type=template&id=20d317cf&scoped=true&"
import script from "./InstitutionalQnrThanksView.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrThanksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d317cf",
  null
  
)

export default component.exports